// import React, { useState } from "react";
// import TownPlanningSidebar from "../components/TownPlanningSidebar";
// import styles from "../styles/TownPlanningDashboard.module.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { FaArrowLeft, FaSearch, FaDownload, FaFilter, FaCalculator, FaFilePdf } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// import { faBars } from "@fortawesome/free-solid-svg-icons";

// export default function Disclaimer() {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const navigate = useNavigate();
//   const handleBack = () => {
//     navigate("/")
//   };
//   return (
//     <div
//       className={styles.homeScreenContainer}
//       style={{
//         height: "100vh",
//         overflow: "hidden",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       {/* Header */}
//       <div className={styles.homeScreenHeader}>
//         {/* <button
//           onClick={() => setIsSidebarOpen(true)}
//           className={styles.homeScreenMenuBtn}
//         >
//           <FontAwesomeIcon icon={faBars} />
//         </button> */}


//         <button className={styles.homeScreenMenuBtn} onClick={handleBack}>
//           <FaArrowLeft />
//         </button>


//         <TownPlanningSidebar
//           isOpen={isSidebarOpen}
//           onClose={() => setIsSidebarOpen(false)}
//         />

//         <h2 style={{ color: "white" }}>Disclaimer</h2>
//       </div>

//       {/* Scrollable Content Area */}
//       <div
//         style={{
//           flex: 1,
//           overflowY: "auto",
//           padding: "20px",
//           color: "white",
//         }}
//       >
//         {/* <p style={{ textAlign: "justify" }}>
//       * The app developer or promoter is "NOT A GOVERNMENT ENTITY NOR AFFILIATED WITH ONE".
// * Through this app, we aim to provide a curated collection of publicly available documents & general information which is sourced from government websites/ portals like maharashtra.gov.in, dtp.maharashtra.gov.in, urban.maharashtra.gov.in, and social media public groups.
// * All information is provided solely for reference. Its authenticity is not guaranteed, and it should not be relied upon in legal proceedings or official matters. 
// * The app is not designed to address the specific circumstances of any individual or organization. For specific legal, professional, or administrative advice, users are encouraged to consult a qualified professional or contact the relevant government office directly. 
// * The owner or developer does not assume any responsibility or liability regarding the completeness, accuracy, or timeliness of the content. 
// * Some sections may link to external websites beyond the control of the owner or developer, who cannot be held accountable for their content.
//  </p> */}


// <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
//   <li>
//     The app developer or promoter is <strong>NOT A GOVERNMENT ENTITY NOR AFFILIATED WITH ONE</strong>.
//   </li>

//   <li>
//     Through this app, we aim to provide a curated collection of publicly available documents and general information sourced from government websites/portals such as maharashtra.gov.in, dtp.maharashtra.gov.in, urban.maharashtra.gov.in, and public social media groups.
//   </li>

//   <li>
//     All information is provided solely for reference. Its authenticity is not guaranteed, and it should not be relied upon in legal proceedings or official matters.
//   </li>

//   <li>
//     The app is not designed to address the specific circumstances of any individual or organization. For specific legal, professional, or administrative advice, users are encouraged to consult a qualified professional or contact the relevant government office directly.
//   </li>

//   <li>
//     The owner or developer does not assume any responsibility or liability regarding the completeness, accuracy, or timeliness of the content.
//   </li>

//   <li>
//     Some sections may link to external websites beyond the control of the owner or developer, who cannot be held accountable for their content.
//   </li>
// </ul>

//         {/* <p style={{ textAlign: "justify" }}>
//           Some sections may link to external websites beyond the control of the owner or developer, who cannot be held accountable for their content.

//         </p> */}

//         {/* <p style={{ textAlign: "justify" }}>
//           All information is provided solely for reference. Its authenticity is not guaranteed, and it should not be relied upon in legal proceedings or official matters. The app is not designed to address the specific circumstances of any individual or organization. For specific legal, professional, or administrative advice, users are encouraged to consult a qualified professional or contact the relevant government office directly.
//         </p> */}
//       </div>
//     </div>
//   );
// }







import React from "react";
import { useNavigate } from "react-router-dom";
import { 
  ArrowLeft, 
  ShieldAlert, 
  ExternalLink, 
  Scale, 
  Globe, 
  AlertTriangle 
} from "lucide-react";

export default function Disclaimer() {
  const navigate = useNavigate();
  
  const handleBack = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col">
      {/* --- HEADER --- */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center gap-4">
          <button 
            onClick={handleBack} 
            className="p-2.5 hover:bg-slate-100 rounded-xl transition-all text-slate-600"
          >
            <ArrowLeft size={22} />
          </button>
          <h2 className="text-lg font-black text-slate-900 uppercase tracking-tight">Legal Notice</h2>
        </div>
      </div>

      {/* --- CONTENT AREA --- */}
      <main className="flex-1 max-w-3xl mx-auto px-4 py-10 w-full">
        <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-slate-400/30 ring-1 ring-slate-200 overflow-hidden">
          
          {/* Top Banner */}
          <div className="p-8 bg-[#111827] text-white flex justify-between items-center">
            <div>
              <h3 className="text-xl font-black tracking-tight uppercase">Disclaimer</h3>
              <p className="text-xs text-slate-400 font-bold tracking-widest mt-1">Terms of Information Use</p>
            </div>
            <div className="w-12 h-12 bg-red-600/20 text-red-500 rounded-2xl flex items-center justify-center border border-red-500/30">
              <ShieldAlert size={24} />
            </div>
          </div>

          <div className="p-8 md:p-12 space-y-8">
            
            {/* Government Affiliation Alert */}
            <div className="bg-red-50 border border-red-100 p-6 rounded-2xl flex gap-4">
              <AlertTriangle className="text-red-600 shrink-0" size={24} />
              <p className="text-sm font-black text-red-900 leading-relaxed uppercase">
                The app developer or promoter is NOT A GOVERNMENT ENTITY NOR AFFILIATED WITH ONE.
              </p>
            </div>

            {/* Grid of Terms */}
            <div className="grid grid-cols-1 gap-6">
              
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center shrink-0 border border-slate-100">
                  <Globe className="text-slate-500" size={18} />
                </div>
                <p className="text-slate-600 text-sm font-medium leading-relaxed">
                  Through this app, we aim to provide a curated collection of publicly available documents and general information sourced from government portals such as <span className="font-bold text-slate-900">maharashtra.gov.in</span>, <span className="font-bold text-slate-900">dtp.maharashtra.gov.in</span>, and <span className="font-bold text-slate-900">urban.maharashtra.gov.in</span>.
                </p>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center shrink-0 border border-slate-100">
                  <Scale className="text-slate-500" size={18} />
                </div>
                <p className="text-slate-600 text-sm font-medium leading-relaxed">
                  All information is provided solely for reference. Its authenticity is not guaranteed, and it should not be relied upon in legal proceedings or official matters.
                </p>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center shrink-0 border border-slate-100">
                  <ExternalLink className="text-slate-500" size={18} />
                </div>
                <p className="text-slate-600 text-sm font-medium leading-relaxed">
                  Some sections may link to external websites beyond the control of the owner or developer, who cannot be held accountable for their content.
                </p>
              </div>

            </div>

            {/* Final Professional Note */}
            <div className="pt-6 border-t border-slate-100">
              <p className="text-xs text-slate-400 font-bold uppercase tracking-wide leading-loose">
                The owner or developer does not assume any responsibility or liability regarding the completeness, accuracy, or timeliness of the content. For specific legal or administrative advice, please consult a qualified professional or contact the relevant government office directly.
              </p>
            </div>
          </div>
        </div>

        <p className="text-center mt-10 text-slate-400 text-[10px] font-bold uppercase tracking-widest">
          PropIntel Intelligence Platform • v1.0.4
        </p>
      </main>
    </div>
  );
}